import { useState, useEffect } from 'react';
import { Play, Clock } from 'lucide-react';

export default function PlayDelayModal({ gymnastName, onPlay, onClose }) {
  const [countdown, setCountdown] = useState(null);
  const [selectedDelay, setSelectedDelay] = useState(null);

  useEffect(() => {
    if (countdown !== null && countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0) {
      // Countdown finished, play music
      onPlay();
    }
  }, [countdown, onPlay]);

  const handleDelaySelect = (seconds) => {
    setSelectedDelay(seconds);
    if (seconds === 0) {
      onPlay();
    } else {
      setCountdown(seconds);
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-[100] p-4"
      onClick={onClose}
      data-testid="play-delay-modal"
    >
      <div 
        className="glass-card max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-2xl font-bold mb-4 text-center" data-testid="modal-title">
          {gymnastName}
        </h2>

        {countdown !== null && countdown > 0 ? (
          <div className="text-center py-8" data-testid="countdown-display">
            <div className="text-8xl font-bold mb-4 text-[#ff3131]">
              {countdown}
            </div>
            <div className="text-xl opacity-80">
              Get ready...
            </div>
          </div>
        ) : countdown === 0 ? (
          <div className="text-center py-8" data-testid="playing-message">
            <div className="text-4xl font-bold text-[#ff3131] mb-2">
              Playing Now!
            </div>
          </div>
        ) : (
          <div className="space-y-3">
            <button
              onClick={() => handleDelaySelect(0)}
              className="btn-primary w-full flex items-center justify-center gap-3 py-4"
              data-testid="play-instantly-button"
            >
              <Play size={24} />
              Play Instantly
            </button>

            <button
              onClick={() => handleDelaySelect(5)}
              className="btn-primary w-full flex items-center justify-center gap-3 py-4"
              data-testid="delay-5-button"
            >
              <Clock size={24} />
              Delay 5 Seconds
            </button>

            <button
              onClick={() => handleDelaySelect(10)}
              className="btn-primary w-full flex items-center justify-center gap-3 py-4"
              data-testid="delay-10-button"
            >
              <Clock size={24} />
              Delay 10 Seconds
            </button>

            <button
              onClick={onClose}
              className="btn-secondary w-full py-3"
              data-testid="cancel-button"
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
